<template>
    <div class="c-price" flex="cross:bottom">
        <span class="rmb">￥</span>
        <span class="price">{{showPrice[0]}}</span>
        <span class="small-price">.{{showPrice[1]}}</span>
    </div>
</template>

<script>
export default {
    props: {
        price: {
            type: Number,
            default: 0
        }
    },
    computed: {
        showPrice(){
            if(!this.price){
                return ['0', '00'];
            }
            let p = this.price + '';
            p = p.split(".");

            return [p[0], p[1] ? p[1] : '00'];
        }
    }
}
</script>
<style lang="scss" scoped>
    .rmb{
        font-size: 12px;
        color: #999;
    }
    .price{
        font-size: 16px;
        color: red;
    }
    .small-price{
        font-size: 12px;
        color: red;
    }
</style>


// WEBPACK FOOTER //
// src/components/CPrice.vue